'use strict';



const $ = require('jquery');
const confirmFormSubmit = require('./confirm-form-submit');
const formClassName = 'js-confirm-prefunding';
const inputClassName = 'js-confirm-prefunding-amount';
const updateButtonClassName = 'js-confirm-prefunding-update';
const $form = $(`.${formClassName}`);
const $inlineForm = $form.filter('[data-inline]');
const FORM_GLOBAL = 'FORM_GLOBAL';
const FORM_LOAN = 'FORM_LOAN';
const FORM_RATE = 'FORM_RATE';



confirmFormSubmit($form, $form => {

	const type = (() => {
		if($form.data('loan')) {
			return FORM_LOAN;
		}
		if($form.data('rate-form')) {
			return FORM_RATE;
		}
		return FORM_GLOBAL;
	})();

	return getMessage(type, $form);

});



const updateButton = {
	enable($button) {
		$button
			.removeClass('c-button--muted')
			.removeAttr('disabled');
	},
	disable($button) {
		$button
			.addClass('c-button--muted')
			.attr('disabled', 'disabled');
	}
};



$inlineForm.each(function() {

	const $form = $(this);
	const $updateButton = $form.find(`.${updateButtonClassName}`);

	$form.one('focus', `.${inputClassName}`, function() {
		const $input = $(this);
		$form.data('initialValue', $input.val());
	});

	$form.on('change', `.${inputClassName}`, function() {

		const $input = $(this);
		const dirty = $input.val() !== $form.data('initialValue');

		const method = dirty ?
			'enable' :
			'disable';

		updateButton[method]($updateButton);

	});

});



function getMessage(type, $form) {

	const loan = $form.data('loan');
	const amount = $form.find('option:selected').text();

	const messages = {
		[FORM_GLOBAL]: $form => `
			<h2 class='[  c-heading  c-heading--dark  ]  u-beta'>Update all pre-funding</h2>
			<p>Are you sure you wish to set your pre-funding for all existing and future pipeline loans to <strong>${amount}</strong>?</p>
			<ul class='c-content-list'>
				<li class='c-content-list__item'>This will override any <em>loan</em> specific pre-funding preferences you have previously set.</li>
				<li class='c-content-list__item'>This will override any <em>rate</em> specific pre-funding preferences you have previously set.</li>
			</ul>
		`,
		[FORM_RATE]: $form => {
			const $rates = $form.find('.js-prefunding-rate');
			return `
				<h2 class='[  c-heading  c-heading--dark  ]  u-beta'>Update rate specific pre-funding</h2>
				<p>Are you sure you wish to set your pre-funding for all existing and future pipeline loans?</p>
				<table class='c-table'>
					<thead>
						<tr>
							<th class='[  c-table__cell  c-table__cell--title  ]'>Loan rate</th>
							<th class='[  c-table__cell  c-table__cell--title  ]'>Pre-funding</th>
						</tr>
					</thead>
					<tbody>
						${
							$rates.map(function() {
								const amount = $(this).find('option:selected').text();
								const label = $(this).find('.js-prefunding-label').text();
								return `
									<tr>
										<td class='c-table__cell'>
											<span class='c-label'>${label}</span>
										</td>
										<td class='c-table__cell'>
											<span class='c-label'>${amount}</span>
										</td>
									</tr>
								`;
							}).get().join('')
						}
					</tbody>
				</table>
				<ul class='c-content-list'>
					<li class='c-content-list__item'>These preferences will override any <em>loan</em> specific pre-funding preferences you have previously set.</li>
					<li class='c-content-list__item'>These preferences will override any <em>global</em> pre-funding preference you have previously set.</li>
				</ul>
			`;
		},
		[FORM_LOAN]: $form => `
			<h2 class='[  c-heading  c-heading--dark  ]  u-beta'>${loan || 'Update loan pre-funding'}</h2>
			<p>Are you sure you wish to set your pre-funding for this loan to <strong>${amount}</strong>?</p>
		`
	};

	return typeof messages[type] === 'function' ?
		messages[type]($form) :
		'';

}